import React from "react";

export default function MaintenancePage() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-6">
            <div className="text-center max-w-md">
                <h1 className="font-display text-3xl mb-3">Estamos actualizando el sitio</h1>
                <p className="text-neutral-500">Volvemos enseguida. Gracias por tu paciencia.</p>
            </div>
        </div>
    );
}